module.exports = __webpack_public_path__ + "img/9788960170919.bfa98a48.jpg";